module.exports = __webpack_public_path__ + "static/media/fightscout-desktop-screens.1d2b2ccf.png";